(function () {
  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }
  function apply(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('cellfy-theme', theme); } catch (e) {}
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(theme === 'dark'));
    });
  }
  // estado inicial dos botões
  document.addEventListener('DOMContentLoaded', function () {
    var t = currentTheme();
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(t === 'dark'));
    });
  });
  // clique (delegado — funciona pro toggle do header e do menu mobile)
  document.addEventListener('click', function (e) {
       var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    // CELLFY: tema travado (Black Friday), não alterna nem grava preferência
    if (document.documentElement.hasAttribute('data-theme-locked')) return;
    apply(currentTheme() === 'dark' ? 'light' : 'dark');
  });
})();